//Button and sub-buttons should be moved to common lib
import Button from "./Button";
import RemoveButton from "./RemoveButton";

export default Button;
export { Button, RemoveButton };
